import { Component } from "@angular/core";
import { WorkCell } from "../../../model";
import { LocationSchemaThingGroupActionTableColumn } from "../custom-table-column/location-schema-thing-group-action-table-column";
import { ButtonActionValue, ClickableTableValueComponent } from "./clickable-table-value.component";

@Component({
    selector: 'location-schema-thing-group-action-table-value',
    template: `
        <button mat-icon-button [matMenuTriggerFor]="menu">
            <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
            <button
                *ngIf="column.workCells?.length"
                mat-menu-item [matMenuTriggerFor]="moveMenu">
                <span custom-label="moveToProperty"></span>
            </button>
            <button mat-menu-item
                (click)="performDelete()">
                <span custom-label="deleteButton"></span>
            </button>
        </mat-menu>
        <mat-menu #moveMenu="matMenu">
            <button *ngFor="let workCell of column.workCells" mat-menu-item
                (click)="performMove(workCell)">
                <span>{{ workCell.name | localize }}</span>
            </button>
        </mat-menu>
    `
})
export class LocationSchemaThingGroupActionTableValueComponent extends ClickableTableValueComponent<LocationSchemaThingGroupActionTableColumn> {

    getValue(): any {
        return null;
    }

    performMove(workCell: WorkCell): void {
        const value = { thingId: this.element.id, workCellId: workCell.id };
        this.emitLocationSchemaThingGroupAction('MOVE_DEVICE_TO_WORK_CELL', value);
    }

    performDelete(): void {
        const value = { thingId: this.element.id };
        this.emitLocationSchemaThingGroupAction('DELETE_DEVICE', value);
    }

    private emitLocationSchemaThingGroupAction(action: string, value: any): void {
        let buttonAction: ButtonActionValue = { action: action, value: value, index: this.rowIndex };
        this.buttonAction.emit(buttonAction);
    }

}